/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { useLayout } from '../core'

const Footer: FC = () => {
  const { classes } = useLayout()
  return (
    <div style={{ width: '100%' }} className='footer bg-primary py-4  container-fluid' id='kt_footer'>
      {/* begin::Container */}
      <h3 className='text-center text-white'>
        AIOLOS - <b className='text-info'>A</b>rtificial <b className='text-info'>I</b>ntelligence
        To
        <b className='text-info'>OL</b>s for <b className='text-info'>O</b>utbreak Detection and
        Respon<b className='text-info'>S</b>e
      </h3>
      <div
        className={`${classes.footerContainer} d-flex flex-column flex-md-row flex-stack justify-content-center `}
      >
        {/* begin::Copyright */}
        <div className='text-dark order-2 order-md-1'>
          <span className='text-gray-400 fw-bold me-1'>Copyright</span>
          <a
            href='https://aiolos-project.org/'
            target='_blank'
            className='text-muted text-hover-white fw-bold me-2 fs-6'
          >
            AIOLOS 2024 - Designed and powered by Impact Healthcare
          </a>
          <a href="https://www.impact-healthcare.fr/en/">   <img src="https://www.impact-healthcare.fr/wp-content/uploads/2024/07/Impact_healthcare_logo-blanc-1.png" style={{ width: "80px" }} /></a>

        </div>
        {/* end::Copyright */}

        {/* begin::Menu */}

        {/* end::Nav */}
      </div>
      {/* end::Container */}
    </div>
  )
}

export { Footer }
